import { axios } from '../config/axios';

const endPoint = '/project/processing-candidate';


const uploadProcessingCandidate = async (formData) => {
    return axios.post(`${endPoint}/upload-processing-candidate`, formData);
}

const updateProcessingCandidate = async (formData) => {
    return axios.post(`${endPoint}/update-processing-candidate`, formData);
}

const getListByPageByProjectMasterId = async (projectMasterId, searchTerm, pageNumber, limit) => {
    return axios.post(`${endPoint}/list-by-project-master-with-pagination`, {
        projectMasterId: projectMasterId,
        search: searchTerm,
        page: pageNumber,
        limit: limit
    });
}

const getProcessingDataByProjectMasterId = async (projectMasterId) => {
    return axios.post(`${endPoint}/processing-data`, {
        projectMasterId: projectMasterId,
    });
}

const deleteProcessingCandidate = (processingCandidateId) => {
    return axios.delete(`${endPoint}/delete/${processingCandidateId}`);
}

const deleteAllProcessingCandidates = (projectMasterId) => {
    return axios.delete(`${endPoint}/delete-all/${projectMasterId}`);
}

export {
    uploadProcessingCandidate,
    updateProcessingCandidate,
    getListByPageByProjectMasterId,
    getProcessingDataByProjectMasterId,
    deleteProcessingCandidate,
    deleteAllProcessingCandidates,
}